import { render } from "./BookingsPage.vue?vue&type=template&id=b1250da4"
import script from "./BookingsPage.vue?vue&type=script&lang=js"
export * from "./BookingsPage.vue?vue&type=script&lang=js"

import "./BookingsPage.vue?vue&type=style&index=0&id=b1250da4&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__